import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import { brands, keywords, publishers, categories } from 'api';
import { initialFilters } from 'reducers/SearchFeedReducer.js';
import { SET_SEARCH_FEED_FILTER } from 'components/Pages/SearchFeed/actions.js';
import { SAVE_RICH_BRAND_DATA, SAVE_RICH_PUBLISHER_DATA } from 'components/Global/Filters/actions.js';

export const TOGGLE_ADVANCED_SEARCH = 'TOGGLE_ADVANCED_SEARCH';

export const UPDATE_ADVANCED_SEARCH_DATES = 'UPDATE_ADVANCED_SEARCH_DATES';
export const UPDATE_ADVANCED_SEARCH_ENTITY = 'UPDATE_ADVANCED_SEARCH_ENTITY';
export const UPDATE_ADVANCED_SEARCH = 'UPDATE_ADVANCED_SEARCH';

export const FETCH_ADVANCED_SEARCH_KEYWORDS = 'FETCH_ADVANCED_SEARCH_KEYWORDS';
export const FETCHED_ADVANCED_SEARCH_KEYWORDS = 'FETCHED_ADVANCED_SEARCH_KEYWORDS';
export const SET_ADVANCED_SEARCH_KEYWORDS_FILTER = 'SET_ADVANCED_SEARCH_KEYWORDS_FILTER';
export const RESET_ADVANCED_SEARCH_KEYWORDS_FILTER = 'RESET_ADVANCED_SEARCH_KEYWORDS_FILTER';

export const FETCH_ADVANCED_SEARCH_CATEGORIES = 'FETCH_ADVANCED_SEARCH_CATEGORIES';
export const FETCHED_ADVANCED_SEARCH_CATEGORIES = 'FETCHED_ADVANCED_SEARCH_CATEGORIES';
export const SET_ADVANCED_SEARCH_CATEGORIES_FILTER = 'SET_ADVANCED_SEARCH_CATEGORIES_FILTER';

export const FETCH_ADVANCED_SEARCH_BRANDS = 'FETCH_ADVANCED_SEARCH_BRANDS';
export const FETCHED_ADVANCED_SEARCH_BRANDS = 'FETCHED_ADVANCED_SEARCH_BRANDS';
export const SET_ADVANCED_SEARCH_BRANDS_FILTER = 'SET_ADVANCED_SEARCH_BRANDS_FILTER';
export const RESET_ADVANCED_SEARCH_BRANDS_FILTER = 'RESET_ADVANCED_SEARCH_BRANDS_FILTER';

export const FETCH_ADVANCED_SEARCH_PUBLISHERS = 'FETCH_ADVANCED_SEARCH_PUBLISHERS';
export const FETCHED_ADVANCED_SEARCH_PUBLISHERS = 'FETCHED_ADVANCED_SEARCH_PUBLISHERS';
export const SET_ADVANCED_SEARCH_PUBLISHERS_FILTER = 'SET_ADVANCED_SEARCH_PUBLISHERS_FILTER';
export const RESET_ADVANCED_SEARCH_PUBLISHERS_FILTER = 'RESET_ADVANCED_SEARCH_PUBLISHERS_FILTER';

export const fetchAllKeywords = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  store: getState().AdvancedSearch.keywordsList,
  fetchingActionType: FETCH_ADVANCED_SEARCH_KEYWORDS,
  fetchedActionType: FETCHED_ADVANCED_SEARCH_KEYWORDS,
  apiCall: filters => keywords.getKeywordsList(filters),
});

export const fetchAllCategories = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().AdvancedSearch.categoriesList,
  fetchingActionType: FETCH_ADVANCED_SEARCH_CATEGORIES,
  fetchedActionType: FETCHED_ADVANCED_SEARCH_CATEGORIES,
  apiCall: filters => categories.getCategoriesList(filters),
});

export const fetchAllBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  store: getState().AdvancedSearch.brandsList,
  fetchingActionType: FETCH_ADVANCED_SEARCH_BRANDS,
  fetchedActionType: FETCHED_ADVANCED_SEARCH_BRANDS,
  apiCall: filters => brands.getBrandsList(filters),
});

export const fetchAllPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  store: getState().AdvancedSearch.publishersList,
  fetchingActionType: FETCH_ADVANCED_SEARCH_PUBLISHERS,
  fetchedActionType: FETCHED_ADVANCED_SEARCH_PUBLISHERS,
  apiCall: filters => publishers.getPublishersList(filters),
});

export const submitAdvancedSearch = () => (dispatch, getState) => {
  const advancedSearchState = getState().AdvancedSearch;
  dispatch({ type: SET_SEARCH_FEED_FILTER, filters: initialFilters });

  dispatch({ type: SAVE_RICH_BRAND_DATA, data: advancedSearchState.richBrandData });
  dispatch({ type: SAVE_RICH_PUBLISHER_DATA, data: advancedSearchState.richPublisherData });

  dispatch({ type: SET_SEARCH_FEED_FILTER,
    filters: {
      startDate: advancedSearchState.startDate,
      endDate: advancedSearchState.endDate,
      content_type: advancedSearchState.content_type,
      content_format: advancedSearchState.content_format,
      article_length: advancedSearchState.article_length,
      brand_ids: advancedSearchState.brand_ids,
      publisher_ids: advancedSearchState.publisher_ids,
      keyword_tags: advancedSearchState.keyword_tags,
      searchQuery: advancedSearchState.searchQuery,
      searchBy: advancedSearchState.searchBy,
    } });
};
